(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-product-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingredient-feature-carousel')) {
    customElements.define(
      'ingredient-feature-carousel',
      class IngredientFeatureCarousel extends HTMLElement {
        connectedCallback() {
          if (this.initialized) {
            return;
          }

          this.track = this.querySelector('.ingredient-product-feature__ingredients-track');
          this.viewport = this.querySelector('.ingredient-product-feature__ingredients-viewport');
          this.source = this.querySelector('[data-ingredient-carousel-source]');
          this.dragOffset = 0;
          this.isDragging = false;
          this.hasDragged = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.toggleButton = this.closest('.ingredient-product-feature__ingredients')?.querySelector(
            '[data-ingredient-carousel-toggle]'
          );
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onClickCapture = this.onClickCapture.bind(this);
          this.onToggle = this.onToggle.bind(this);

          if (!this.track || !this.viewport || !this.source) {
            return;
          }

          this.initialized = true;
          if (!this.reducedMotion) {
            this.viewport.addEventListener('pointerdown', this.onPointerDown);
            this.viewport.addEventListener('click', this.onClickCapture, true);
          }

          this.toggleButton?.addEventListener('click', this.onToggle);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.refresh());
            this.resizeObserver.observe(this);
            this.resizeObserver.observe(this.source);
          }

          this.refresh();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();

          if (this.viewport) {
            this.viewport.removeEventListener('pointerdown', this.onPointerDown);
            this.viewport.removeEventListener('click', this.onClickCapture, true);
          }

          this.toggleButton?.removeEventListener('click', this.onToggle);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          this.initialized = false;
        }

        refresh() {
          const sourceWidth = this.source.getBoundingClientRect().width;
          const viewportWidth = this.viewport.getBoundingClientRect().width;
          const trackGap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;

          if (!sourceWidth || !viewportWidth) {
            return;
          }

          this.track
            .querySelectorAll('[data-ingredient-carousel-clone]')
            .forEach((clone) => clone.remove());

          const requiredGroups = this.reducedMotion
            ? 1
            : Math.max(2, Math.ceil((viewportWidth * 2) / sourceWidth) + 1);

          for (let index = 1; index < requiredGroups; index += 1) {
            const clone = this.source.cloneNode(true);
            clone.removeAttribute('data-ingredient-carousel-source');
            clone.setAttribute('data-ingredient-carousel-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
            clone
              .querySelectorAll('a, button, input, select, textarea, [tabindex]')
              .forEach((element) => element.setAttribute('tabindex', '-1'));
            clone
              .querySelectorAll('[data-shopify-editor-block]')
              .forEach((element) => element.removeAttribute('data-shopify-editor-block'));
            this.track.appendChild(clone);
          }

          this.groupWidth = sourceWidth + trackGap;
          this.style.setProperty(
            '--ingredient-feature-ingredients-group-width',
            `${this.groupWidth}px`
          );
          this.setDragOffset(this.dragOffset);
          this.classList.add('is-ready');
        }

        onPointerDown(event) {
          if (event.button !== undefined && event.button !== 0) {
            return;
          }

          this.isDragging = true;
          this.hasDragged = false;
          this.startX = event.clientX;
          this.startOffset = this.getCurrentOffset();
          this.setDragOffset(this.startOffset);
          this.classList.add('is-dragging');
          this.track.style.transform = `translate3d(${this.dragOffset}px, 0, 0)`;
          this.track.style.animation = 'none';
          this.viewport.setPointerCapture?.(event.pointerId);
          window.addEventListener('pointermove', this.onPointerMove, { passive: false });
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        onPointerMove(event) {
          if (!this.isDragging) {
            return;
          }

          const delta = event.clientX - this.startX;

          if (Math.abs(delta) > 4) {
            this.hasDragged = true;
          }

          if (this.hasDragged) {
            event.preventDefault();
          }

          this.setDragOffset(this.startOffset + delta);
          this.track.style.transform = `translate3d(${this.dragOffset}px, 0, 0)`;
        }

        onPointerUp() {
          if (!this.isDragging) {
            return;
          }

          this.isDragging = false;
          this.classList.remove('is-dragging');
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          this.track.style.removeProperty('transform');
          this.track.style.removeProperty('animation');
          window.setTimeout(() => {
            this.hasDragged = false;
          }, 0);
        }

        onClickCapture(event) {
          if (!this.hasDragged) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          this.hasDragged = false;
        }

        onToggle() {
          const isPaused = this.classList.toggle('is-user-paused');
          const label = isPaused
            ? this.toggleButton.dataset.playLabel
            : this.toggleButton.dataset.pauseLabel;

          this.toggleButton.classList.toggle('is-paused', isPaused);
          this.toggleButton.setAttribute('aria-label', label);
          this.toggleButton.setAttribute('title', label);
        }

        getCurrentOffset() {
          const transform = getComputedStyle(this.track).transform;

          if (!transform || transform === 'none') {
            return this.dragOffset || 0;
          }

          try {
            return new DOMMatrixReadOnly(transform).m41 || 0;
          } catch {
            return this.dragOffset || 0;
          }
        }

        setDragOffset(value) {
          const width = this.groupWidth || 0;

          if (!width) {
            this.dragOffset = value;
          } else {
            this.dragOffset = ((value % width) + width) % width;

            if (this.dragOffset > 0) {
              this.dragOffset -= width;
            }
          }

          this.style.setProperty(
            '--ingredient-feature-ingredients-drag-offset',
            `${this.dragOffset}px`
          );
        }
      }
    );
  }

  const initIngredientProductFeatureReveal = (root = document) => {
    const sections = root.matches?.('.ingredient-product-feature')
      ? [root]
      : root.querySelectorAll('.ingredient-product-feature');

    sections.forEach((section) => {
      if (section.dataset.revealBound === 'true') {
        return;
      }

      section.dataset.revealBound = 'true';
      section.classList.add('is-reveal-ready');

      if (
        window.Shopify?.designMode ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              observer.disconnect();
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.16 }
      );

      section.ingredientFeatureObserver = observer;
      observer.observe(section);
    });
  };

  const initIngredientProductFeatureMedia = (root = document) => {
    const buttons = root.matches?.('[data-ingredient-media-toggle]')
      ? [root]
      : root.querySelectorAll('[data-ingredient-media-toggle]');

    buttons.forEach((button) => {
      if (button.dataset.mediaToggleBound === 'true') {
        return;
      }

      const media = button.closest('.ingredient-product-feature__media');
      const videos = [...media.querySelectorAll('video')];

      if (!videos.length) {
        return;
      }

      button.dataset.mediaToggleBound = 'true';

      const updateState = () => {
        const isPaused = videos.every((video) => video.paused);
        const label = isPaused ? button.dataset.playLabel : button.dataset.pauseLabel;

        button.classList.toggle('is-paused', isPaused);
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      };

      videos.forEach((video) => {
        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        videos.forEach((video) => {
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.pause();
        });
      }

      button.addEventListener('click', () => {
        const shouldPlay = videos.every((video) => video.paused);

        if (shouldPlay) {
          videos.forEach((video) => video.play().catch(updateState));
        } else {
          videos.forEach((video) => video.pause());
        }

        updateState();
      });

      updateState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initIngredientProductFeatureReveal();
      initIngredientProductFeatureMedia();
    });
  } else {
    initIngredientProductFeatureReveal();
    initIngredientProductFeatureMedia();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initIngredientProductFeatureReveal(event.target);
    initIngredientProductFeatureMedia(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      .querySelectorAll('.ingredient-product-feature')
      .forEach((section) => section.ingredientFeatureObserver?.disconnect());
  });

  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('.ingredient-product-feature__ingredient-card');
    const carousel = card?.closest('ingredient-feature-carousel');

    if (!card || !carousel || card.closest('[data-ingredient-carousel-clone]')) {
      return;
    }

    const offset = card.offsetLeft - 16;
    carousel.classList.add('is-editor-paused');
    carousel.setDragOffset(-Math.max(0, offset));
    carousel.track.style.animation = 'none';
    carousel.track.style.transform = `translate3d(${carousel.dragOffset}px, 0, 0)`;
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const carousel = event.target.closest('ingredient-feature-carousel');

    if (!carousel) {
      return;
    }

    carousel.classList.remove('is-editor-paused');
    carousel.track.style.removeProperty('animation');
    carousel.track.style.removeProperty('transform');
  });

  } catch(e) { console.error(e); }
})();
})();
